module.exports = __webpack_public_path__ + "img/pr-3.0a29bc3a.png";